/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  Create8Params,
  CreatePrequalifiedLeadParams,
  CreateSpecializedLeadWithDemoParams,
  DemoBookingRequestDto,
  DemoCreateRequestDto,
  DemoCreatedDto,
  LeadCreateRequestDto,
  LeadCreatedDto,
  LeadFunnelValuesResponseDto,
  LeadIdWithEmailDto,
  LeadSelfSignupRegisteredDto,
  LeadSelfSignupRequestDto,
  LeadUpdateRequestDto,
  LeadUpdatedDto,
  LeadWaitlistRequestDto,
  PrequalifiedLeadCreateRequestDto,
  PrequalifiedLeadCreatedDto,
  ProductTourEventDto,
  SpecializedLeadWithDemoCreateRequest,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class LeadController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags lead-controller
   * @name Create8
   * @request POST:/api/v1/lead
   */
  create = (query: Create8Params, data: LeadCreateRequestDto, params: RequestParams = {}) =>
    this.http.request<LeadCreatedDto, any>({
      path: `/v1/lead`,
      method: 'POST',
      query: query,
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createPath = '/v1/lead'
  static createMethod = 'POST'
  /**
   * No description
   *
   * @tags lead-controller
   * @name Waitlist
   * @request POST:/api/v1/lead/{leadId}/waitlist
   */
  waitlist = (leadId: string, data: LeadWaitlistRequestDto, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/lead/${leadId}/waitlist`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static waitlistPath = '/v1/lead/${leadId}/waitlist'
  static waitlistMethod = 'POST'
  /**
   * No description
   *
   * @tags lead-controller
   * @name SelfSignup
   * @request POST:/api/v1/lead/{leadId}/self-signup
   */
  selfSignup = (leadId: string, data: LeadSelfSignupRequestDto, params: RequestParams = {}) =>
    this.http.request<LeadSelfSignupRegisteredDto, any>({
      path: `/v1/lead/${leadId}/self-signup`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static selfSignupPath = '/v1/lead/${leadId}/self-signup'
  static selfSignupMethod = 'POST'
  /**
   * No description
   *
   * @tags lead-controller
   * @name SaveProductTourEvent
   * @request POST:/api/v1/lead/{leadId}/product-tour-events
   */
  saveProductTourEvent = (leadId: string, data: ProductTourEventDto, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/lead/${leadId}/product-tour-events`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static saveProductTourEventPath = '/v1/lead/${leadId}/product-tour-events'
  static saveProductTourEventMethod = 'POST'
  /**
   * No description
   *
   * @tags lead-controller
   * @name CreateDemo
   * @request POST:/api/v1/lead/{leadId}/demo
   */
  createDemo = (leadId: string, data: DemoCreateRequestDto, params: RequestParams = {}) =>
    this.http.request<DemoCreatedDto, any>({
      path: `/v1/lead/${leadId}/demo`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createDemoPath = '/v1/lead/${leadId}/demo'
  static createDemoMethod = 'POST'
  /**
   * No description
   *
   * @tags lead-controller
   * @name Book
   * @request POST:/api/v1/lead/{leadId}/demo/booked
   */
  book = (leadId: string, data: DemoBookingRequestDto, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/lead/${leadId}/demo/booked`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static bookPath = '/v1/lead/${leadId}/demo/booked'
  static bookMethod = 'POST'
  /**
   * No description
   *
   * @tags lead-controller
   * @name CreateSpecializedLeadWithDemo
   * @request POST:/api/v1/lead/specialized/with-demo
   */
  createSpecializedLeadWithDemo = (
    query: CreateSpecializedLeadWithDemoParams,
    data: SpecializedLeadWithDemoCreateRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<LeadIdWithEmailDto, any>({
      path: `/v1/lead/specialized/with-demo`,
      method: 'POST',
      query: query,
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createSpecializedLeadWithDemoPath = '/v1/lead/specialized/with-demo'
  static createSpecializedLeadWithDemoMethod = 'POST'
  /**
   * No description
   *
   * @tags lead-controller
   * @name CreatePrequalifiedLead
   * @request POST:/api/v1/lead/prequalified
   */
  createPrequalifiedLead = (
    query: CreatePrequalifiedLeadParams,
    data: PrequalifiedLeadCreateRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<PrequalifiedLeadCreatedDto, any>({
      path: `/v1/lead/prequalified`,
      method: 'POST',
      query: query,
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createPrequalifiedLeadPath = '/v1/lead/prequalified'
  static createPrequalifiedLeadMethod = 'POST'
  /**
   * No description
   *
   * @tags lead-controller
   * @name Update8
   * @request PATCH:/api/v1/lead/{leadId}/funnel-step/{currentFunnelStep}
   */
  update = (
    leadId: string,
    currentFunnelStep:
      | 'emailPrequalified'
      | 'email'
      | 'numberOfEmployees'
      | 'registrationCountry'
      | 'legalForm'
      | 'productInterests'
      | 'cardSpend'
      | 'cardSpendSmallSpender'
      | 'cardsNeed'
      | 'isCreditRequired'
      | 'creditNeed'
      | 'numberOfInvoices'
      | 'invoicesNeed'
      | 'funnelIntent'
      | 'engagementStage'
      | 'erpSystem'
      | 'waitlist'
      | 'notForYou'
      | 'demoBookingP0'
      | 'demoBookingP1'
      | 'demoBookingP2'
      | 'selfSignup'
      | 'demoFromScratchP0',
    data: LeadUpdateRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<LeadUpdatedDto, any>({
      path: `/v1/lead/${leadId}/funnel-step/${currentFunnelStep}`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updatePath = '/v1/lead/${leadId}/funnel-step/${currentFunnelStep}'
  static updateMethod = 'PATCH'
  /**
   * No description
   *
   * @tags lead-controller
   * @name GetFunnelValues
   * @request GET:/api/v1/lead/{leadId}/funnel-values
   */
  getFunnelValues = (leadId: string, params: RequestParams = {}) =>
    this.http.request<LeadFunnelValuesResponseDto, any>({
      path: `/v1/lead/${leadId}/funnel-values`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getFunnelValuesPath = '/v1/lead/${leadId}/funnel-values'
  static getFunnelValuesMethod = 'GET'
}
